import type {
  DocStatus,
  AccessType,
  DocCollection,
  ModerationStatus,
  PublicationStatus,
} from "@/models/document";
import type { BadgeProps } from "@/components/ui";

type Meta = { label: string; variant: NonNullable<BadgeProps["variant"]> };

export const DOC_STATUS_META: Record<DocStatus, Meta> = {
  draft: { label: "Bản nháp", variant: "neutral" },
  pending: { label: "Chờ duyệt", variant: "warning" },
  approved: { label: "Đã duyệt", variant: "info" },
  rejected: { label: "Bị từ chối", variant: "danger" },
  published: { label: "Đã đăng", variant: "success" },
  hidden: { label: "Đã ẩn", variant: "neutral" },
  archived: { label: "Lưu trữ", variant: "neutral" },
};

/** Nhãn hình thức truy cập (đặc tả mục 3). */
export const ACCESS_TYPE_META: Record<AccessType, Meta> = {
  free: { label: "Miễn phí", variant: "success" },
  vip: { label: "Dành cho VIP", variant: "warning" },
  paid: { label: "Trả phí", variant: "info" },
};

/** Nhãn dòng sản phẩm — "Độc quyền" là dấu nhận diện, không phải quyền truy cập. */
export const DOC_COLLECTION_META: Record<DocCollection, Meta> = {
  standard: { label: "Tiêu chuẩn", variant: "neutral" },
  exclusive: { label: "Độc quyền", variant: "ai" },
};

export const MODERATION_STATUS_META: Record<ModerationStatus, Meta> = {
  draft: { label: "Bản nháp", variant: "neutral" },
  pending_review: { label: "Chờ duyệt", variant: "warning" },
  approved: { label: "Đã duyệt", variant: "info" },
  rejected: { label: "Bị từ chối", variant: "danger" },
  suspended: { label: "Tạm khóa", variant: "danger" },
};

export const PUBLICATION_STATUS_META: Record<PublicationStatus, Meta> = {
  unpublished: { label: "Chưa đăng", variant: "neutral" },
  published: { label: "Đã đăng", variant: "success" },
  archived: { label: "Lưu trữ", variant: "neutral" },
};

/** Định dạng giá VND, hoặc "Miễn phí". */
export function formatPrice(isPremium: boolean, price: number): string {
  if (!isPremium || price <= 0) return "Miễn phí";
  return new Intl.NumberFormat("vi-VN").format(price) + "₫";
}

/** Định dạng giá theo VND (số nguyên) — không suy đoán miễn phí. */
export function formatVnd(price: number): string {
  return new Intl.NumberFormat("vi-VN").format(price) + "₫";
}
